module.exports = __webpack_public_path__ + "media/images/icons/v2/chevron-up-edf443ea10e9523de4f1702e8569bb09.svg";